import { render, staticRenderFns } from "./FolderChooseDialog.vue?vue&type=template&id=664b0582"
import script from "./FolderChooseDialog.vue?vue&type=script&lang=js"
export * from "./FolderChooseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports